import React, { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";

/**
 * 
 * @param {props} id number for identifying 
 * @param {props} desc string display string
 * @param {props} remove function to remove this hover
 * 
 * @returns bootstrap Badge
 */
const HoverBadge = ({id, desc, remove}) => {

    const [hover, setHover] = useState(false);

    return (
        <Badge
            onClick={() => remove(id)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            key={id}
            id={`badge-${id}`}
            style={{marginRight: "5px", cursor: "pointer"}}
            bg="energo"
            className="animate-slide-left"
            >
                <Row>
                    <Col xs={hover? "10": "12"}>
                        {desc} 
                    </Col>
                    <Col hidden={!hover} xs="2" className="text-end text-danger">
                        {hover ? <span bg="white">X</span> : null}
                    </Col>
                </Row>
            </Badge>
    )
}

export default HoverBadge;